import { JARVIS_PVT_FEED_URL } from '../../constants';

const AXIOS_BASE_CONFIG = {
  jarvisConfigUrl: `${JARVIS_PVT_FEED_URL}/toi_servers/server_config?db_env=published&application=toi-spa`,
  maxRedirects: 3,
  jarvisRefreshIntervalMs: 2 * 60 * 1000,
  jarvisBootstrapTimeoutMs: 30000,
  agentRetireGraceMs: 90000,
};

export default AXIOS_BASE_CONFIG;
